export const budgetRoutes = {
  create: [],
  view: [
    {
      path: 'budget',
      title: `trip budget`,
      loadComponent: () =>
        import('./pages/budget-section/budget-section.page').then((m) => m.BudgetSectionPage),
    },
  ],
};
